var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 overflow-auto"},[_c('d-remote-monitoring-scoring-rules')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }